module.exports = {
  title: 'Grid List Layout Animation with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2023-01-11',
  slug: 'animated-grid-list',
  tags: ['reanimated'],
};
